import { Tooltip } from '..';
import { HideTooltipContext, ShowTooltipContext } from './context';
import { useTooltipHandler } from './hooks';

type Props = {
  children: React.ReactNode;
};

export const TooltipProvider: React.FC<Props> = props => {
  const { anchorEl, content, showTooltip, hideTooltip } = useTooltipHandler();

  return (
    <ShowTooltipContext.Provider value={{ showTooltip }}>
      <HideTooltipContext.Provider value={{ hideTooltip }}>
        <Tooltip anchorEl={anchorEl} content={content} />
        {props.children}
      </HideTooltipContext.Provider>
    </ShowTooltipContext.Provider>
  );
};
